import { createContext, useContext, useState, useEffect, useCallback } from 'react'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [token, setToken] = useState(() => localStorage.getItem('token'))
  const [loading, setLoading] = useState(true)

  const logout = useCallback(() => {
    setUser(null)
    setToken(null)
    localStorage.removeItem('token')
    localStorage.removeItem('user')
  }, [])

  useEffect(() => {
    if (token) {
      try {
        const parts = token.split('.')
        const payload = parts[1] ? JSON.parse(atob(parts[1])) : {}
        if (payload.exp && payload.exp * 1000 < Date.now()) {
          logout()
        } else {
          const stored = localStorage.getItem('user')
          const userData = stored ? JSON.parse(stored) : { id: payload.userId, email: payload.email, isAdmin: payload.isAdmin }
          setUser(userData)
        }
      } catch {
        logout()
      }
    } else {
      setUser(null)
    }
    setLoading(false)
  }, [token, logout])

  const login = (userData, authToken) => {
    const fullUser = { ...userData, isAdmin: userData.isAdmin }
    setUser(fullUser)
    setToken(authToken)
    localStorage.setItem('token', authToken)
    localStorage.setItem('user', JSON.stringify(fullUser))
  }

  return (
    <AuthContext.Provider value={{ user, token, loading, login, logout, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used within AuthProvider')
  return ctx
}
